module.exports = __webpack_public_path__ + "img/banner_01.6594d7e7.jpg";